import { render, staticRenderFns } from "./AuthInvite.vue?vue&type=template&id=368c1da2&"
import script from "./AuthInvite.vue?vue&type=script&lang=js&"
export * from "./AuthInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368c1da2')) {
      api.createRecord('368c1da2', component.options)
    } else {
      api.reload('368c1da2', component.options)
    }
    module.hot.accept("./AuthInvite.vue?vue&type=template&id=368c1da2&", function () {
      api.rerender('368c1da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth/src/features/auth/screens/AuthInvite.vue"
export default component.exports